import React from 'react';

export const CloseIcon = props => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="6.51465" y="7.92896" width="2" height="22" transform="rotate(-45 6.51465 7.92896)" fill="#212121" />
    <rect x="22.0713" y="6.51477" width="2" height="22" transform="rotate(45 22.0713 6.51477)" fill="#212121" />
  </svg>
);
